export const participatingMemberToPlayerObject = (member = {}) => {
    const { id, ...otherMemberProperties } = member;

    return {
        memberId: id,
        ...otherMemberProperties,
    };
};
